var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pages > 1
    ? _c(
        "div",
        { staticClass: "table-pagination" },
        _vm._l(_vm.showedPages, function(page) {
          return _c(
            "div",
            {
              key: page,
              class: [
                "table-pagination__element",
                { selected: page === _vm.currentPage }
              ],
              on: {
                click: function($event) {
                  return _vm.$emit("change-page", page)
                }
              }
            },
            [_vm._v("\n    " + _vm._s(page) + "\n  ")]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }